import React from 'react';
import { Calendar, ExternalLink } from 'lucide-react';

const BlogSection = () => {
  const blogPosts = [
    {
      id: 1,
      title: "Your Guide to Small Business Marketing",
      date: "June 24, 2025",
      description: "Marketing is one of the most powerful tools a small business can use to grow, compete, and build lasting customer relationships. In today's digital landscape, effective marketing strategies can make the difference between success and failure.",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=250&fit=crop&crop=center",
      readMoreLink: "#"
    },
    {
      id: 2,
      title: "The Best Social Media Trends of 2025",
      date: "June 19, 2025",
      description: "Social media is never static—and in 2025, it's evolving more rapidly than ever. With AI tools in full swing, Gen Z reshaping platforms, and new features launching constantly, staying ahead of trends is crucial for business success.",
      image: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=400&h=250&fit=crop&crop=center",
      readMoreLink: "#"
    },
    {
      id: 3,
      title: "What Are Display Ads?",
      date: "June 12, 2025",
      description: "Display ads are a cornerstone of modern digital advertising. These visual advertisements appear across websites, mobile apps, and platforms, typically featuring images, videos, or interactive content to capture audience attention and drive conversions.",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop&crop=center",
      readMoreLink: "#"
    }
  ];

  return (
    <div className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-red-500 font-semibold text-sm uppercase tracking-wider mb-4">
            BLOG
          </h2>
          <h3 className="text-3xl lg:text-4xl font-bold text-gray-800">
            Latest News and Blog from Azucarai
          </h3>
        </div>

        {/* Blog Posts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <article key={post.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Content */}
              <div className="p-6">
                {/* Title */}
                <h4 className="text-xl font-bold text-gray-800 mb-3 leading-tight">
                  {post.title}
                </h4>

                {/* Date */}
                <div className="flex items-center space-x-2 mb-4">
                  <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
                  <div className="flex items-center space-x-2 text-gray-500 text-sm">
                    <Calendar size={14} />
                    <span>{post.date}</span>
                  </div>
                </div>

                {/* Description */}
                <p className="text-gray-600 leading-relaxed mb-4 line-clamp-3">
                  {post.description}
                </p>

                {/* Read More Link */}
                <a
                  href={post.readMoreLink}
                  className="inline-flex items-center space-x-2 text-red-600 hover:text-red-700 font-medium text-sm transition-colors"
                >
                  <span>Read More About This Blog</span>
                  <ExternalLink size={14} />
                </a>
              </div>
            </article>
          ))}
        </div>

        {/* View All Button */}
        <div className="text-center mt-12">
          <button className="bg-red-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors">
            View All Blog Posts
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogSection;





